var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#134563;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Navicon",
    transform: "translate(330.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-19",
    points: "-321.8,-219 -274.3,-219 -274.3,-212.7 -321.8,-212.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-20",
    points: "-321.8,-203.2 -274.3,-203.2 -274.3,-196.8 -321.8,-196.8    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-21",
    points: "-321.8,-187.3 -274.3,-187.3 -274.3,-181 -321.8,-181    "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.8246383d64efa9f03a0e042da063a88a.svg";
export { ForwardRef as ReactComponent };